module.exports = __webpack_public_path__ + "img/SUNU-assurances.d85d9f1d.jpg";